import TrackingService from "./tracking_service";
import BrandTile from "./brandTile";
import {TrackingFeatureLabels} from "../types";

export default class PromoBrandShopPromo {
    readonly promoType: string;
    readonly featureOrder: number;
    readonly filledSlots: number;
    readonly brandTiles: BrandTile[];
    readonly featureIndex: number;
    readonly featureId: string;
    readonly masFeatureTrackingLabels: TrackingFeatureLabels;
    private readonly trackingService: TrackingService;

    constructor(container: Element) {

        this.promoType = this._getPromoType(container);
        this.featureOrder = this._getFeatureOrder(container);
        this.masFeatureTrackingLabels = this._getMasFeatureTrackingLabels(container);
        this.featureIndex = this._getFeatureIndex(container);
        this.featureId = this._getFeatureId(container)
        const brandTileDoms = container.querySelectorAll('.promo_brandshoppromo--tile');
        this.brandTiles = Array.from(brandTileDoms).map((brandTileDom: Element, index: number) => new BrandTile(brandTileDom, index + 1))
        this.filledSlots = this.brandTiles.length;
        this.trackingService = new TrackingService();
        this.trackLoaded(container);
        this.registerScrollTrackingObserver(brandTileDoms);

        [].map.call(brandTileDoms, (brandTileDom: HTMLElement, index: number) => {
            brandTileDom.addEventListener("click", this.trackClick(this.brandTiles[index]), false);
        })
    }

    trackClick(brandTile: BrandTile): () => void {
        const self = this;
        return function () {
            self.trackingService.sendClickTrackingEvent(self.featureOrder, self.featureIndex, self.featureId, brandTile, self.filledSlots, self.promoType, self.masFeatureTrackingLabels);
        }
    }

    trackLoaded(container: Element): void {
        if (!container.getAttribute("data-tracked")) {
            container.setAttribute("data-tracked", "true");
            this.trackingService.sendLoadedTracking(this.featureOrder, this.featureIndex, this.featureId, this.promoType, this.brandTiles, this.masFeatureTrackingLabels);
        }
    }

    registerScrollTrackingObserver(brandTiles: NodeListOf<Element>): void {
        /*                                     */
        const trackingObserver = new IntersectionObserver((entries) => {
            const entriesToTrack = entries
                .filter((entry) => entry.isIntersecting);

            if (entriesToTrack.length > 0) {
                const positionsToTrack = entriesToTrack
                    .map((entry) => parseInt(entry.target.getAttribute("data-tile-position")!))

                this.trackingService.sendScrollTrackingEvent(this.promoType, this.featureIndex, this.featureId, positionsToTrack);

                entriesToTrack.forEach((entry) => {
                    trackingObserver.unobserve(entry.target);
                });
            }

        });
        brandTiles.forEach((brandTile) => {
            trackingObserver.observe(brandTile);
        });
    }

    _getPromoType(container: Element): string {
        return container.getAttribute("data-promo-type")!;
    }

    _getFeatureOrder(container: Element): number {
        const dataFeatureOrder = container.closest('[data-feature-order]')?.getAttribute('data-feature-order');
        return dataFeatureOrder ? parseInt(dataFeatureOrder, 0) : -1;
    }

    _getMasFeatureTrackingLabels(container: Element): TrackingFeatureLabels {
        const dataFeatureTrackingLabels = container.closest('[data-feature-tracking-labels]')?.getAttribute("data-feature-tracking-labels");
        return dataFeatureTrackingLabels ? JSON.parse(dataFeatureTrackingLabels) : {};
    }

    _getFeatureIndex(container: Element): number {
        return parseInt(container.getAttribute('data-feature-index')!, 0);
    }

    _getFeatureId(container: Element): string {
        return container.getAttribute('data-feature-id')!;
    }

}
